<template>
    <div class="login-view">
      <Login @login-success="onLoginSuccess" />
    </div>
  </template>
  
  <script>
  import Login from '@/components/product-viewer/Login.vue';
  
  export default {
    name: 'LoginView',
    components: {
      Login
    },
    methods: {
      onLoginSuccess(user, role) {
        this.$router.push('/categories');
      }
    }
  }
  </script>
  
  <style scoped>
  .login-view {
    min-height: 100vh;
    width: 100%;
  }
  </style>